import { useEffect, useRef, useState, createRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { router } from '@inertiajs/react';

const onSubmit = (e, uploadType) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    router.post(`/uploads/new/${uploadType}`, formData, { forceFormData: true, preserveState: false });
};

export function Dropzone(props) {
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const {required, name, changer, uploadType} = props; 
  const hiddenInputRef = useRef(null);
  const formRef = useRef(null);

  const {getRootProps, getInputProps, rootRef} = useDropzone({
    accept: {
      'image/*': []
    },
    maxFiles: 1,
    disabled: isUploading,
    onDrop: (incomingFiles) => {
      if (hiddenInputRef.current) {
        setIsUploading(true);

        // Note the specific way we need to munge the file into the hidden input
        // https://stackoverflow.com/a/68182158/1068446
        const dataTransfer = new DataTransfer();
        incomingFiles.forEach((v) => {
          dataTransfer.items.add(v);
        });
        hiddenInputRef.current.files = dataTransfer.files;
      }

      setFiles(incomingFiles);
    }
  });

  useEffect(() => {
    if (!files) return;

    const delayDebounceFn = setTimeout(() => {
      // Trigger native HTML form submission programmatically
      formRef.current?.requestSubmit();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [files]);

  return (
    <form ref={formRef} onSubmit={(e) => onSubmit(e, uploadType)}>
      <fieldset className="mx-auto fieldset bg-base-200 border-base-300 rounded-md max-w-lg border p-4 bg-gray-200">
        <div className="my-auto bg-white rounded-md">
          <div {...getRootProps({ className: 'dropzone' })}>
            <input type ="file" name={name} required={required} style ={{opacity: 0}} ref={hiddenInputRef} className="w-full mx-auto" />
            <input {...getInputProps()} />
            <p className="flex items-center justify-center min-h-24 my-auto mb-3 text-black">{isUploading ? (<div className="block"><div>Uploading</div><br /><progress className="block progress w-56"></progress></div>) : 'Drag and drop an image here or click/tap to select an image!'}</p>
          </div>
        </div>
      </fieldset>
    </form>
  );
}
